module.exports = __webpack_public_path__ + "img/icon-logout.871008f6.svg";